var _module = require('../components/module');

/*
hideZeroMinutes
Hides the :00 part of a hh:mm time string
*/
_module.filter('hideZeroMinutes', [
    function () {
        return function hideZeroMinutes(str) {
            return (str||'').replace(':00', '');
        };
    }
]);
